module.exports = __webpack_public_path__ + "static/media/t2.bc544c11.png";